import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CompaniesComponent } from './companies.component';



const bigpictureRoutes: Routes = [
    { path: '', component:  CompaniesComponent}
];

@NgModule({
    imports: [
        RouterModule.forChild(bigpictureRoutes)
    ],
    exports: [RouterModule]
})

export class CompaniesRoutingModule {

}



// WEBPACK FOOTER //
// C:/www/onetouchSuperAdmin/src/app/pages/companies/companies-routing.module.ts